<template>
    <div class="paper">
        <div class="container-fluid">
            <div class="tab-content col-12">
                <b-row>
                    <b-col cols="12" md="2">
                        <div><img class="photo-border-square" v-bind:src="ProfilePhotoURL()" style="width:100%;border-radius:20px;" /></div>
                    </b-col>
                    <b-col cols="12" md="10">
                        <h1><span>{{ UserProfile.FirstName }} {{UserProfile.LastName}}</span></h1>
                        <h5><span><i>{{ UserProfile.Email }}</i></span></h5>
                        <h5><span><i>{{ UserProfile.SubProgramProfileTitle }}</i></span></h5>
                    </b-col>
                </b-row>
                <div class="row" style="margin-top: 10px;">
                    <div class="col col-md-12">
                        <div class="record-tabs">
                            <span class="d-none d-sm-block">
                                <b-nav>
                                    <div v-for="pane in Panes">
                                        <b-nav-item v-on:click="ChangePaneShown(pane.name)" v-bind:class="{ active: PaneShown == pane.name }">{{pane.name}}</b-nav-item>
                                    </div>
                                </b-nav>
                            </span>
                            <b-nav>
                                <span class="d-sm-none">
                                    <b-nav-item-dropdown :text=changeDropdownName id="mobileDropdown">
                                        <div v-for="pane in Panes">
                                            <b-dropdown-item v-on:click="ChangePaneShown(pane.name)" v-bind:class="{ active: PaneShown == pane.name }">{{pane.name}}</b-dropdown-item>
                                        </div>
                                    </b-nav-item-dropdown>
                                </span>
                            </b-nav>
                        </div>
                        <div v-show="PaneShown == 'Roles and Permissions'" id="descriptions">

                            <h4>Roles</h4>
                            <p>
                                <span v-for="roles in UserProfile.Roles"><div>{{ roles }}</div></span>
                            </p>

                            <h4>Permissions</h4>
                            <p>
                                <span v-for="permissions in UserProfile.Permissions"><div>{{ permissions }}</div></span>
                            </p>

                        </div>
                        <div v-show="PaneShown == 'Sub Programs' && UserProfile.AssignedSubPrograms.length > 0">
                            <h4>Sub Programs</h4>
                            <vuetable :fields="SubProgramTableOptions.Fields"
                                      :data-manager="DataManager"
                                      pagination-path=""
                                      :api-mode="false"
                                      class="vue-datatable"
                                      ref="datatable">
                                <template slot="FormattedName" scope="props">
                                    <div class="FormattedName">
                                        <b-row no-gutters>
                                            <b-col md="auto" style="padding-right:1rem;">
                                                {{props.rowData.HomeControllerName}} - {{props.rowData.Name}}
                                            </b-col>
                                        </b-row>
                                    </div>
                                </template>
                                <template slot="Title" scope="props">
                                    <div class="Title">
                                        <b-row no-gutters>
                                            <b-col md="auto" style="padding-right:1rem;">
                                                <div v-if="props.rowData.EmployeeMemberships.length != 0">
                                                    {{props.rowData.EmployeeMemberships[0].SubProgramRole}}
                                                </div>
                                            </b-col>
                                        </b-row>
                                    </div>
                                </template>
                                <template slot="StartDate" scope="props">
                                    <div class="StartDate">
                                        <b-row no-gutters>
                                            <b-col md="auto" style="padding-right:1rem;">
                                                <div v-if="props.rowData.EmployeeMemberships.length != 0">
                                                    {{formatDate(props.rowData.EmployeeMemberships[0].StartDate)}}
                                                </div>
                                            </b-col>
                                        </b-row>
                                    </div>
                                </template>
                            </vuetable>
                            <p>
                                <span class="bold">WelligentID: </span>
                                <IntegerEditor v-bind:old-value="UserProfile.WelligentID"
                                               v-bind:record-id="userID"
                                               v-bind:edit-mode="EditMode"
                                               data-label="WelligentID"
                                               property-name="WelligentID"
                                               update-method="Admin/UserManagement/UpdateEmployeeWelligentID"
                                               :global-update="true" />
                            </p>
                            <div class="row">
                                <div class="col padding-top-md pointer" v-on:click="ToggleEditMode()">
                                    <font-awesome-icon :icon="['fa', 'edit']" />
                                    <span v-if="EditMode"> Edit Mode: ON</span>
                                    <span v-else> Edit Mode: OFF</span>
                                </div>
                            </div>
                        </div>

                        <div v-show="PaneShown == 'Supervisors and Supervisees'" id="descriptions">

                            <h4 style="display:inline; padding-right:0.5rem;">Supervisor(s)</h4>
                            <font-awesome-icon :icon="['fa', 'plus']" v-on:click="ShowAddSupervisor()" v-if="EditMode" class="pointer green" />
                            <b-modal ref="AddSupervisor-component-modal" title="Add Supervisor" @show="ClearAddForm" hide-footer>
                                <b-container>
                                    <b-form @submit="AddSupervisor">
                                        <b-row>
                                            <b-col>
                                                <div class="form-group">
                                                    <label>Supervisor to add:</label>
                                                    <select class="form-control" v-model="NewSupervisorOrSupervisee">
                                                        <option v-for="user in UserList" v-if="user.MembershipEmployeeSubProgram.length > 0" :value="user.MembershipEmployeeSubProgram[0].EmployeeID">
                                                            {{ user.Email }}
                                                        </option>
                                                    </select>
                                                    <label>Supervisor Role</label>
                                                    <b-row no-gutters="true">
                                                        <b-col cols="12" style="margin-bottom: 1rem">
                                                            <select v-model="SupervisorRole" class="form-control" required>
                                                                <option value="Operational Supervisor">Operational Supervisor</option>
                                                                <option value="Clinical Reviewer">Clinical Reviewer</option>
                                                            </select>
                                                            <div class="form-group" v-if="SupervisorRole == 'Clinical Reviewer'">
                                                                <label>Percent of Notes Requiring Review (leave blank for ALL notes requiring review)</label>
                                                                <input type="number" v-model="ApprovalPercentage" class="form-control" />
                                                            </div>
                                                        </b-col>
                                                    </b-row>
                                                </div>
                                            </b-col>
                                        </b-row>
                                        <b-row class="modal-btn-row">
                                            <div class="modal-btn-row-div">
                                                <b-button size="md" variant="secondary" @click="CancelAddSupervisor()">
                                                    CANCEL
                                                </b-button>
                                                <b-button size="md" variant="success" type="submit">
                                                    SAVE
                                                </b-button>
                                            </div>
                                        </b-row>
                                    </b-form>
                                </b-container>
                            </b-modal>
                            <p>
                                <span v-for="supervisor in UserProfile.EmployeeSupervisors">
                                    <div>
                                        <router-link :to="'/Admin/EmployeeProfile/' + supervisor.SupervisorEmployee.ApplicationUserID">
                                            {{supervisor.SupervisorEmployee.Person.FullName}} - {{supervisor.SupervisorRole}} <span v-if="supervisor.SupervisorRole == 'Clinical Reviewer'"><span v-if="supervisor.ApprovalPercentage != null">{{supervisor.ApprovalPercentage}}%</span><span v-else>100%</span> Notes Require Approval</span>
                                        </router-link>
                                        
                                        <ActionButtonWithIcon style="padding-left:0.5rem;" v-if="EditMode"
                                                  :requires-confirmation="true"
                                                  confirmation-string="WARNING: You are about to delete this role.  Are you sure?"
                                                  endpoint="Core/User/DeleteMembershipEmployeeSupervisor"
                                                  :payload="{Id: supervisor.Id}"
                                                  :perform-global-update="false"
                                                  button-variant="success"
                                                  button-string=""
                                                  button-size="md"
                                                  emit-on-success="role-deleted"
                                                  v-on:success="GetEmployeePrivateProfile"
                                                  icon-prefix="fa"
                                                  icon-suffix="trash-alt"
                                                  icon-color="red"
                                                  method="POST"/>
                                    </div>
                                </span>
                            </p>
                            <p>
                                <h4 style="display:inline; padding-right:0.5rem;">Supervisee(s)</h4>
                                <font-awesome-icon :icon="['fa', 'plus']" v-on:click="ShowAddSupervisee()" v-if="EditMode" class="pointer green" />
                                <b-modal ref="AddSupervisee-component-modal" title="Add Supervisee" @show="ClearAddForm" hide-footer>
                                    <b-container>
                                        <b-form @submit="AddSupervisee">
                                            <b-row>
                                                <b-col>
                                                    <div class="form-group">
                                                        <label>Supervisee to add:</label>
                                                        <select class="form-control" v-model="NewSupervisorOrSupervisee">
                                                            <option v-for="user in UserList" v-if="user.MembershipEmployeeSubProgram.length > 0" :value="user.MembershipEmployeeSubProgram[0].EmployeeID">
                                                                {{ user.Email }}
                                                            </option>
                                                        </select>
                                                        <label>Supervisor Role</label>
                                                        <b-row no-gutters="true">
                                                            <b-col cols="12" style="margin-bottom: 1rem">
                                                                <select v-model="SupervisorRole" class="form-control" required>
                                                                    <option value="Operational Supervisor">Operational Supervisor</option>
                                                                    <option value="Clinical Reviewer">Clinical Reviewer</option>
                                                                </select>
                                                                <div class="form-group" v-if="SupervisorRole == 'Clinical Reviewer'">
                                                                    <label>Percent of Notes Requiring Review (leave blank for ALL notes requiring review)</label>
                                                                    <input type="number" v-model="ApprovalPercentage" class="form-control" />
                                                                </div>
                                                            </b-col>
                                                        </b-row>
                                                    </div>
                                                </b-col>
                                            </b-row>
                                            <b-row class="modal-btn-row">
                                                <div class="modal-btn-row-div">
                                                    <b-button size="md" variant="secondary" @click="CancelAddSupervisee()">
                                                        CANCEL
                                                    </b-button>
                                                    <b-button size="md" variant="success" type="submit">
                                                        SAVE
                                                    </b-button>
                                                </div>
                                            </b-row>
                                        </b-form>
                                    </b-container>
                                </b-modal>
                                <span v-for="supervisee in UserProfile.EmployeeSupervisees">
                                    <div>
                                        <router-link :to="'/Admin/EmployeeProfile/' +supervisee.SuperviseeEmployee.ApplicationUserID">
                                            {{supervisee.SuperviseeEmployee.Person.FullName}} - {{supervisee.SupervisorRole}} <span v-if="supervisee.SupervisorRole == 'Clinical Reviewer'"><span v-if="supervisee.ApprovalPercentage != null">{{supervisee.ApprovalPercentage}}%</span><span v-else>100%</span> Notes Require Approval</span>
                                        </router-link>
                                        <ActionButtonWithIcon style="padding-left:0.5rem;" v-if="EditMode"
                                                  :requires-confirmation="true"
                                                  confirmation-string="WARNING: You are about to delete this role.  Are you sure?"
                                                  endpoint="Core/User/DeleteMembershipEmployeeSupervisor"
                                                  :payload="{Id: supervisee.Id}"
                                                  :perform-global-update="false"
                                                  button-variant="success"
                                                  button-string=""
                                                  button-size="md"
                                                  emit-on-success="role-deleted"
                                                  v-on:success="GetEmployeePrivateProfile" 
                                                  icon-prefix="fa"
                                                  icon-suffix="trash-alt"
                                                  icon-color="red"
                                                  method="POST"/>
                                    </div>
                                </span>
                            </p>
                            <div class="row">
                                <div class="col padding-top-md pointer" v-on:click="ToggleEditMode()">
                                    <font-awesome-icon :icon="['fa', 'edit']" />
                                    <span v-if="EditMode"> Edit Mode: ON</span>
                                    <span v-else> Edit Mode: OFF</span>
                                </div>
                            </div>
                        </div>
                        <div v-show="PaneShown == 'Caseloads'" id="descriptions">

                            <h4>Caseloads</h4>
                            <p>
                                <span v-for="client in UserProfile.Clients">
                                    <div>{{client.Client.Person.FullName}} - {{ client.SubProgram.Name }}</div>
                                </span>
                            </p>

                        </div>
                        <div v-show="PaneShown == 'Trainings'">
                            <h4>Airtable Trainings:</h4>
                            <p v-for="training in EmployeeTrainings">{{ training.fields['Session Name'] }}</p>

                        </div>
                        <div v-show="PaneShown == 'Signatures'">
                            <div class="col col-md-12">
                                <b-row>
                                    <h4 v-if="UserSignatureImage">
                                        Current Active Signature:
                                        <img v-bind:src="UserSignatureImage" style="width:100%; max-width:2400px;" />
                                    </h4>
                                    <b-form @submit="CreateOrUpdateUserSignatureImage" ref="SignatureUploadForm">
                                        <h4>Add user signature as an image (.png)</h4>
                                        <b-form-group>
                                            <b-form-file name="SigFile"
                                                         drop-placeholder="Drop image here..."
                                                         accept="image/png"
                                                         required>
                                            </b-form-file>
                                        </b-form-group>
                                        <button type="submit" class="btn btn-success">UPLOAD SIGNATURE</button>
                                    </b-form>
                                </b-row>
                                <b-row>
                                    <h4>Sign a new user signature</h4>
                                </b-row>
                                <b-row>
                                    <button @click="OpenCreateSignatureModal" class="btn btn-success">Create Signature</button>
                                </b-row>
                            </div>
                        </div>
                        <div v-if="UserPrivateProfile.data" v-show="PaneShown == 'Person'">
                            <PersonEditor :edit-mode="true"
                                          :existing-person="UserPrivateProfile.data.Person"
                                          :DOBRequired="false"
                                          :global-update="true"
                                          :inline="true"
                                          end-point="tbd"
                                          :control-buttons="true" 
                                          :employee-record="UserPrivateProfile.data"/>


                        </div>
                    </div>
                </div>
            </div>
            <SignaturePad end-point="Core.User.CreateOrUpdateUserSignatureImage"
                          :additional-payload="{ApplicationUserID: userID}"
                          v-on:success="GetEmployeePrivateProfile()"
                          :in-modal="true"
                          :modal-title="'Signature for ' + UserProfile.Email"
                          ref="SigModalComponent" />
        </div>
    </div>
</template>

<script>
    //import icons
    import { library } from '@fortawesome/fontawesome-svg-core';
    import { faPlus } from '@fortawesome/free-solid-svg-icons';
    library.add(faPlus);
    import { faTrashAlt } from '@fortawesome/free-solid-svg-icons';
    library.add(faTrashAlt);
    import { UserAPI } from '../../services/api/Core/UserAPI.js';
    import Vuetable from 'vuetable-2/src/components/Vuetable';
    import SelectEditor from '../Core/ItemEditors/SelectEditor';
    import IntegerEditor from '../Core/ItemEditors/IntegerEditor';
    // import helper functions
    import SignaturePad from '../Core/CustomInputElements/SignaturePad.vue';
    import ActionButtonWithIcon from '../Admin/ActionButtonWithIcon.vue';
    import PersonEditor from '../Core/ItemEditors/PersonEditor.vue';
    import { EventBus } from '../../services/event-bus.js';
    export default {
        data: function () {
            return {
               NewSupervisorOrSupervisee: '',
               SupervisorRole: '',
               UserList: [],
               EditMode: false,
               userID: this.$route.params.userID,
               UserProfile: [],
               UserSubPrograms: [],
               PaneShown: "Roles and Permissions",
               Panes: [
                   { name: 'Roles and Permissions' },
                   { name: 'Supervisors and Supervisees' },
                   { name: 'Sub Programs' },
                   { name: 'Caseloads' },
                   { name: 'Trainings' },
                   { name: 'Signatures' },
                   { name: 'Person' }
                ],
               EmployeeTrainings: [],
                SubProgramTableOptions: {
                    Fields: [
                        {
                            name: '__slot:FormattedName',
                            title: 'Name',
                        },
                        {
                            name: '__slot:Title',
                            title: 'Title',
                        },
                        {
                            name: '__slot:StartDate',
                            title: 'StartDate',
                        },                      
                    ]
                },
                options: {
                    penColor: "#000000",
                    onBegin:() => { this.$refs.signaturePad.resizeCanvas() }
                }
            };
        },
        created() {
            const userAPI = new UserAPI(this.$baseURL);
            this.userAPI = userAPI;
            this.$store.commit("User.PrivateProfile.Clear");
        },
        methods: {
            DeleteSupervisor(rowData) {
                //let vm = this;
                //vm.$store.commit("UI.BumpLoadsInProgress", 1);
                //this.$MasterAPI.ExecuteAPI('Core.User.DeleteSupervisor',
                //    {
                //        Id: rowData.Id
                //    })
                //    .then((response) => {
                //        vm.$store.commit("UI.BumpLoadsInProgress", -1);
                //        if (response.status == 200) {
                //            this.$refs['add-component-modal'].hide();
                //        }
                //        else {
                //            //show error
                //            if (response.data.hasOwnProperty('errors')) {
                //                EventBus.$emit('transmission-error', response.data.errors);
                //            } else {
                //                EventBus.$emit('transmission-error', ["There was an unspecified error in your transmission"]);
                //            }

                //        }
                //    });
                //this.$MasterAPI.ExecuteRequest("POST", "NEVER USED - CHANGE", {Id: rowData.Id}, this.DeleteSupervisorSuccess, () => { }, true);

            },
            DeleteSupervisorSuccess(response) {
               // this.$refs['add-component-modal'].hide();
            },
            GetEmployeePrivateProfile() {
                this.userAPI.GetSpecifiedEmployeePrivateProfile(this.$route.params.userID).then((data) => {
                    this.UserProfile = data.data.data;
                    if(data.data.data.AssignedSubPrograms != null)
                        this.UserSubPrograms = data.data.data.AssignedSubPrograms;
                    this.$refs.datatable.refresh();
                    this.$store.commit("User.PrivateProfile.Replace", data.data);
                    this.GetEmployeeTrainings();
                });
            },
            GetEmployeeTrainings() {
                this.$MasterAPI.ExecuteRequest("GET", "Training/GetEmployeeTrainings", {EmployeeID: this.UserProfile.EmployeeID}, this.GetEmployeeTrainingsSuccess, () => { }, false);

            },
            GetEmployeeTrainingsSuccess(response) {
                this.EmployeeTrainings = response.data.data;
            },
            ChangePaneShown(paneName) {
                this.PaneShown = paneName;
            },
            formatDate (value, fmt = 'MM/DD/YY', defaultText = '') {
              return (value == null)
                ? defaultText
                : moment(value, 'YYYY-MM-DD').format(fmt)
            },
            ProfilePhotoURL() {
                //if (this.FamilyRecordData.Family.ProfilePhotoFileId == null) {
                    return "/images/NoPhotoOnFile.jpg"
                //} else {
                //    return this.$baseURL + "/API/Core/Files/GetFileContent/profilephoto?FileID=" + this.FamilyRecordData.Family.ProfilePhotoFileId
                //}
            },
            DataManager(sortOrder, pagination) {
                let dataset = this.filteredList(this.UserSubPrograms);
                if (dataset.length > 0) {
                    if (sortOrder.length > 0) {
                        if (sortOrder[0].direction == 'asc') {
                            var firstComp = 1;
                            var secondComp = -1;
                        } else {
                            var firstComp = -1;
                            var secondComp = 1
                        }
                        return dataset.sort((a, b) => (this.$FindProperty(a, sortOrder[0].sortField) > this.$FindProperty(b, sortOrder[0].sortField)) ? firstComp : secondComp);
                    } else {
                        return dataset;
                    }
                    
                } else {
                    return [];
                }
            },
            filteredList(inputData) {
                let vm = this;
                let tData = inputData
                if (tData == null) {
                    return [];
                }
                let tFields = vm.$refs["datatable"].tableFields;
                let visibleData = [];
                tData.forEach(function (row, index) {
                    let rowData = [];
                    tFields.forEach(function (field) {
                        rowData.push(vm.$refs.datatable.renderNormalField(field, row));
                    })
                    visibleData.push(inputData[index]);
                    //if (vm.search == "" || JSON.stringify(rowData).toLowerCase().includes(vm.search.toLowerCase())) {
                    //    visibleData.push(inputData[index]);
                    //}
                });
                return visibleData;                  
            },
            ToggleEditMode() {
                this.EditMode = !this.EditMode;
            },
            ShowAddSupervisor() {
                this.$refs['AddSupervisor-component-modal'].show();
            },
            ShowAddSupervisee() {
                this.$refs['AddSupervisee-component-modal'].show();
            },
            CancelAddSupervisor() {
                this.$refs['AddSupervisor-component-modal'].hide();
            },
            CancelAddSupervisee() {
                this.$refs['AddSupervisee-component-modal'].hide();
            },
            ClearAddForm() {
                this.NewSupervisorOrSupervisee = '';
                this.SupervisorRole = '';
                this.ApprovalPercentage = null;
            },
            GetUsers() {
                this.$MasterAPI.ExecuteRequest("GET", "Admin/UserManagement/GetUsers", {Status: "All"}, this.GetUsersSuccess, () => { }, false);

            },
            GetUsersSuccess(response) {
                this.UserList = response.data.data;
            },
            AddSupervisor(e) {
                e.preventDefault();
                this.$MasterAPI.ExecuteRequest("POST", "Core/User/AddMembershipEmployeeSupervisor", {
                    EmployeeId: this.UserProfile.EmployeeID,
                    SupervisorId: this.NewSupervisorOrSupervisee,
                    SupervisorRole: this.SupervisorRole,
                    ApprovalPercentage: this.ApprovalPercentage
                    }, this.AddSupervisorSuccess, () => { }, true);

            },
            AddSupervisorSuccess(response) {
                this.$refs['AddSupervisor-component-modal'].hide();
                this.GetEmployeePrivateProfile();
            },
            AddSupervisee(e) {
                e.preventDefault();
                this.$MasterAPI.ExecuteRequest("POST", "Core/User/AddMembershipEmployeeSupervisor", {
                        EmployeeId: this.NewSupervisorOrSupervisee,
                        SupervisorId: this.UserProfile.EmployeeID,
                        SupervisorRole: this.SupervisorRole,
                        ApprovalPercentage: this.ApprovalPercentage
                    },this.AddSuperviseeSuccess, () => { }, true);

            },
            AddSuperviseeSuccess(response) {
                this.$refs['AddSupervisee-component-modal'].hide();
                this.GetEmployeePrivateProfile();
            },
            CreateOrUpdateUserSignatureImage(e) {
                e.preventDefault();
                let form = this.$refs['SignatureUploadForm'];
                let formData = new FormData(form);
                formData.append("ApplicationUserID", this.userID);
                this.$MasterAPI.ExecuteRequest("POST", "Admin/UserManagement/CreateOrUpdateUserSignatureImage", formData,this.CreateOrUpdateUserSignatureImageSuccess, () => { }, true);

            },
            CreateOrUpdateUserSignatureImageSuccess(response,form) {
                this.GetEmployeePrivateProfile();
                form.reset();
            },
            OpenCreateSignatureModal() {
                this.$refs['SigModalComponent'].ShowModal();
            }
        },
        components: {
            SelectEditor,
            ActionButtonWithIcon,
            Vuetable,
            SignaturePad,
            PersonEditor,
            IntegerEditor
        },
        mounted() {
            this.GetEmployeePrivateProfile();
            this.GetUsers();
            let vm = this;
            let getProfileFunction = function () {
                vm.GetEmployeePrivateProfile();
            };
            this.$GlobalUpdate.AddGlobalUpdateFunction(getProfileFunction);
        },
        computed: {
            UserPrivateProfile: function () {
                return this.$store.state.User.PrivateProfile;
            },
            changeDropdownName: function () {
                return this.PaneShown;
            },
            UserSignatureImage: function () {
                let upp = this.UserPrivateProfile;
                if (upp.UserId != '') {
                    if (upp.data != null) {
                        return upp.data.SignatureURL;
                    }
                    
                } else {
                    return '';
                }
            }
            //SubProgramFormMemberships: function () {
            //    let subProgram = this.$store.getters["User.PrivateProfile.SubPrograms.GetSubProgram"](this.FamilyRecordData.FamilyProgramMembership.SubProgramID);
            //    return subProgram.FormMemberships.filter(fm => fm.ChartType == "FamilySubProgramMembership");
            //}
        },
        watch: {
            $route(to, from) {
                this.GetEmployeePrivateProfile();
            },
            
        },
    }
    
</script>

<style scoped>
    .record-tabs {
        width: 100%;
        display: inline-block;
    }
    #descriptions{
        /*display:inline-flex;*/
    }
    #colDescriptions{
        white-space:nowrap;
        min-width: max-content;
    }
    .vue-datatable {
        width: 100%;
        display: inline-block;
        overflow-x: auto;
    }
    .paper{
        width: auto !important;
    }
    /*#signature {
  border: double 3px transparent;
  border-radius: 5px;
  background-image: linear-gradient(white, white),
    radial-gradient(circle at top left, #4bc5e8, #9f6274);
  background-origin: border-box;
  background-clip: content-box, border-box;
}*/
</style>